import DateTimePicker from '@components/v2/form/DateTimePicker/DateTimePicker';
import Modal from '@components/v2/ui/Modal/Modal';
import Typography from '@components/v2/ui/Typography/Typography';
import { Grid, Stack } from '@mui/material';
import LangEnum from '../../../../../../../../../lang/LangEnum';
import { CatalogProductsTestIds } from '../../../../../../../../../utils/testIds/CatalogProducts.testIds';
import { useTranslation } from '../../../../../../../../translation/TranslationContext';
import { CatalogCreationAccessCatalogDates } from '../../../../../../../creation/catalogCreationAccess.types';
import { resolveCatalogAccessDateHelperText } from '../../../../../../../creation/catalogCreationAccess.utils';
import { CatalogAccessDates } from '../catalogAccessSection.types';
import { useCatalogAccessChangeDatesModal } from '../hooks/useCatalogAccessChangeDatesModal';

interface CatalogAccessChangeDatesModalProps {
  catalogDates: CatalogCreationAccessCatalogDates;
  onClose: () => void;
  onConfirm: (dates: CatalogAccessDates) => void;
}

const CatalogAccessChangeDatesModal = ({
  catalogDates,
  onClose,
  onConfirm,
}: CatalogAccessChangeDatesModalProps) => {
  const { translate } = useTranslation();

  const { startDate, endDate, handleConfirm } = useCatalogAccessChangeDatesModal({ onConfirm });

  return (
    <Modal
      isOpen
      size="expanded"
      testId={CatalogProductsTestIds.DETAILS_ACCESS_CHANGE_DATES_MODAL}
      header={{ title: LangEnum.CATALOGS_ENTITY_MASS_ACTIONS_CHANGE_ACCESS_DATES }}
      onClose={onClose}
      footer={{
        primaryAction: {
          label: LangEnum.GLOBAL_CHANGE,
          testId: CatalogProductsTestIds.DETAILS_ACCESS_CHANGE_DATES_CONFIRM,
          onClick: handleConfirm,
        },
        secondaryAction: {
          label: LangEnum.GLOBAL_CANCEL_LABEL,
          onClick: onClose,
        },
      }}
    >
      <Stack spacing={2}>
        <Typography variant="body2" sx={{ whiteSpace: 'pre-line', color: 'text.secondary' }}>
          {translate(LangEnum.CATALOGS_ENTITY_MASS_ACTIONS_CHANGE_DATES_DESCRIPTION)}
        </Typography>
        <Grid container spacing={2}>
          <Grid size={{ xs: 12, sm: 6 }}>
            <DateTimePicker
              {...startDate.field}
              label={translate(LangEnum.GLOBAL_INITIAL_DATE)}
              error={!!startDate.fieldState.error}
              helperText={
                startDate.fieldState.error?.message ??
                resolveCatalogAccessDateHelperText({
                  translate,
                  fieldLabel: LangEnum.GLOBAL_INITIAL_DATE,
                  catalogDate: catalogDates.startDate,
                })
              }
            />
          </Grid>
          <Grid size={{ xs: 12, sm: 6 }}>
            <DateTimePicker
              {...endDate.field}
              label={translate(LangEnum.GLOBAL_FINAL_DATE)}
              error={!!endDate.fieldState.error}
              helperText={
                endDate.fieldState.error?.message ??
                resolveCatalogAccessDateHelperText({
                  translate,
                  fieldLabel: LangEnum.GLOBAL_FINAL_DATE,
                  catalogDate: catalogDates.endDate,
                })
              }
            />
          </Grid>
        </Grid>
      </Stack>
    </Modal>
  );
};

export default CatalogAccessChangeDatesModal;
